import {CustomerInfo} from "./customer-info";
import {OnboardingApplicant} from "./onboarding-applicant.model";

export class OnboardingRequest {
  copyAddressFromPrimary?: boolean;
  applicants: OnboardingApplicant[] = new Array();
}
